import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import API_END_POINTS from '../../../core/constants/apiEndPoints';
import { Abbreivation, MasterData } from '../../types/MasterData';
import { AreasResponse } from '../../types/Area';
import { CwpResponse } from '../../types/Cwp';

const {
  MASTER_DATA, ABBREVIATION, GET_AREAS, CWP
} = API_END_POINTS

@Injectable({
  providedIn: 'root'
})
export class MasterDataService {

  private http = inject(HttpClient);
  globalAbbreviations: BehaviorSubject<Record<string, string>> = new BehaviorSubject<Record<string, string>>({});

  constructor() { }

  getMasterData(query: { module: string, key: string }): Observable<{
    status: string,
    data: {
      count: number,
      rows: MasterData[]
    }
  }> {
    return this.http.post<{
      status: string,
      data: {
        count: number,
        rows: MasterData[]
      }
    }>(MASTER_DATA, query)
  }

  fetchAbbreviations(): Observable<{
    status: string,
    data: Abbreivation[];
  }> {
    return this.http.get<{
      status: string,
      data: Abbreivation[];
    }>(ABBREVIATION)
  }

  getAbbreviation(abbreviation: string): string {
    return this.globalAbbreviations.value[abbreviation] || '';
  }

  getCwp(): Observable<CwpResponse> {
    return this.http.get<CwpResponse>(CWP);
  }


}
